import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { Configuration } from 'react-md'

import Login from 'pages/auth/login'
import Send from 'pages/auth/forgot-password/send'
import UpdatePassword from 'pages/auth/forgot-password/update-password'

const AuthRoutes: React.FC = () => {
  return (
    <Configuration>
      <Redirect to='/' />
      <Route path='/' exact component={Login} />
      <Route path='/forgot-password/send' exact component={Send} />
      <Route path='/forgot-password/update-password' exact component={UpdatePassword} />
    </Configuration>
  )
}

export default AuthRoutes
